export const SCHOOLS = [
  "SAAT",
  "SBMS",
  "SOBS",
  "SEET",
  "SOES",
  "SOHT",
  "SICT",
  "SLIT",
  "SMAT",
  "SOPS",
  "SESET",
] as const;

export type SchoolCode = (typeof SCHOOLS)[number];
